import { useState } from "react";
import { noticeTicker } from "@/mocks/appInfo";

const navItems = [
  { label: "首页", href: "#top" },
  { label: "线路状态", href: "#lines" },
  { label: "话题墙", href: "#topics" },
  { label: "今日瓜讯", href: "#news" },
  { label: "热瓜榜", href: "#rank" },
  { label: "App 下载", href: "#app" },
  { label: "常见问题", href: "#faq" },
];

interface SiteHeaderProps {
  onQuickEntry: () => void;
}

export default function SiteHeader({ onQuickEntry }: SiteHeaderProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <div className="w-full overflow-hidden bg-primary-600 text-background-50">
        <div className="flex w-max animate-marquee whitespace-nowrap py-2">
          {[...noticeTicker, ...noticeTicker].map((item, index) => (
            <span key={`${item}-${index}`} className="mx-6 text-xs font-medium tracking-wide md:text-sm">
              {item}
            </span>
          ))}
        </div>
      </div>

      <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
        <div className="mx-auto flex h-16 w-full max-w-[1240px] items-center justify-between gap-4 px-4 md:px-6">
          <a href="#top" className="flex shrink-0 items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-black text-foreground-950">51黑料网</span>
              <span className="mt-0.5 text-[10px] font-medium tracking-widest text-foreground-500">官网导航站</span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={onQuickEntry}
              className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 md:flex"
            >
              <i className="ri-flashlight-fill text-base"></i>
              获取最新地址
            </button>
            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label="打开菜单"
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
            </button>
          </div>
        </div>

        {menuOpen ? (
          <div className="border-t border-background-200 bg-background-50 lg:hidden">
            <nav className="mx-auto grid max-w-[1240px] grid-cols-2 gap-2 px-4 py-4 md:px-6">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="rounded-md bg-background-100 px-3 py-3 text-sm font-medium text-foreground-800"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        ) : null}
      </header>
    </>
  );
}